export enum TaskExecutionType {
  ONCE = 'ONCE', EACH_TIME = 'EACH_TIME'
}
